import React from 'react'

function ManageSubject() {
  return (
    <div>ManageSubject</div>
  )
}

export default ManageSubject